// React
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Page
import LoginPage from '../../page/LoginPage.js';
import PasswordResetPage from '../../page/PasswordResetPage.js';
import RegisterPage from '../../page/RegisterPage.js';

// Components
import SnowEffect from '../custom/SnowEffect.js';

// Utils
import { isChristmasSeason } from '../../utils/dateUtils.js';

function Registration() {
	return (
		<BrowserRouter>
			{isChristmasSeason() && <SnowEffect zIndex={1}/>}
			
			<Routes>
				<Route path='/' element={ <LoginPage/> }/>
				<Route path='/register' element={ <RegisterPage/> }/>
				<Route path='/passwordreset' element={ <PasswordResetPage/> }/>
			</Routes>
		</BrowserRouter>
	)
}

export default Registration;